import React from 'react';

import { Store } from './store';
import { StoreMinified } from './store-minified';
import { StoreLocatorService } from '../store-locator-service';
import { StoreImage } from '../store/store-image';
import smoothscroll from 'smoothscroll-polyfill';

const storeLocatorService = new StoreLocatorService();

export class StoreList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      retailers: [],
      today: new Date().getDay() //REMINDER: 0 is Sunday, 1 is Monday
    };
  }

  componentDidMount() {
    storeLocatorService.getRetailers()
      .then(
        (retailers) => {
          this.setState({
            retailers: retailers
          });
        }
      )
    smoothscroll.polyfill();
  }

  componentDidUpdate() {
    let containerDiv = document.getElementById("nearby-store-list-container");

    if (!this.props.isMobileScreen){
      try {
        containerDiv.scrollTo({top: 0, behavior: 'smooth'});
      }
      catch(err) {
        containerDiv.scrollTop = 0;
      }
    } else {
      try {
        window.scrollTo({top: 0, behavior: 'smooth'});
      }
      catch(err) {
        window.scrollTop = 0;
      }
    }
  }
  render() {
    return (
      <div className={`phase2 store-list-container-yodel${this.props.hide ? " hidden-stores-list" : ""}${this.props.isInPostEnabled ? " -with-filters -in-post-enabled" : ""}`} id='nearby-store-list-container' >
        <ol id='list-top'>
          {this.props.imagesAreAllowed && !this.props.isMobileScreen && this.props.selectedStore && this.props.selectedStore.store_image_url &&
            <StoreImage isLocker={this.props.selectedStore.store_type === 'InPostLocker'} imageUrl={this.props.selectedStore.store_image_url}  />
          }

          {!this.props.isMobileDevice && this.props.selectedStore &&
            <Store
              key={`selected-store-${this.props.selectedStore.id}`}
              origin={this.props.origin}
              store={this.props.selectedStore}
              storeIndex={this.props.selectedStoreIndex}
              retailers={this.state.retailers}
              postcode={this.props.postcode}
              today={this.state.today}
              isMobileDevice={this.props.isMobileDevice}
              showMobileStoreDetail={this.props.showMobileStoreDetail}
              handleMobileThumbnailClicked={this.props.handleMobileThumbnailClicked}
              isInPostStoreLocatorRebrandEnabled={this.props.isInPostStoreLocatorRebrandEnabled}
            />
          }

          {!this.props.showMobileStoreDetail &&
            (
              this.props.stores.map((store, index) => {
                return (
                  this.props.isMobileDevice ?
                    <Store
                      key={store.id}
                      origin={this.props.origin}
                      store={store}
                      storeIndex={index}
                      retailers={this.state.retailers}
                      postcode={this.props.postcode}
                      today={this.state.today}
                      isMobileDevice={this.props.isMobileDevice}
                      showMobileStoreDetail={this.props.showMobileStoreDetail}
                      handleMobileThumbnailClicked={this.props.handleMobileThumbnailClicked}
                      toggleExpandedStore={this.props.toggleExpandedStore}
                      isInPostStoreLocatorRebrandEnabled={this.props.isInPostStoreLocatorRebrandEnabled}
                    /> :
                    <StoreMinified
                      key={store.id}
                      store={store}
                      index={index}
                      retailers={this.state.retailers}
                      isMobileDevice={this.props.isMobileDevice}
                      postcode={this.props.postcode}
                      onStoreSelected={this.props.onStoreSelected}
                      imagesAreAllowed={this.props.imagesAreAllowed}
                      origin={this.props.origin}
                      isInPostStoreLocatorRebrandEnabled={this.props.isInPostStoreLocatorRebrandEnabled}
                    />
                );
              })
            )
          }
        </ol>
      </div>
    );
  }
}
